<div class="home-wrapper">
	<lib-ui-card clipPathT disablePadding class="col-span-2 row-span-2">
		<app-chart-log-day></app-chart-log-day>
	</lib-ui-card>

	<lib-ui-card disablePadding>
		<!--		<app-ui-dict-value recType="dietary_water" recValue="0"></app-ui-dict-value>-->
		<div class="w-full h-full grid grid-rows-4 text-white text-[10px] font-decimaBold">
			@for (
					hkit of hkitList; track hkitVals) {
				@let dict = GlobalDataTypesDict[hkit];
				@let item = hkitVals[hkit];
				<div class="w-full flex-none flex items-center" [ngStyle]="{'color': dict.colorHex}">
					<div class="aspect-square flex-none h-full flex items-center text-[9px]">
						<i class="fa-sharp fal" [ngClass]="'fa-'+dict.icon"></i>
					</div>
					<div class="mr-auto">{{item.valCurrent}}</div>
					<div class="font-decimaLight">{{item.valYesterday}}</div>
					<div class="aspect-square flex-none h-full flex items-center justify-end text-[9px]">
						<i class="fa-sharp fal" [ngClass]="'fa-'+item.trend"></i>
					</div>
				</div>
			}
		</div>
	</lib-ui-card>

	<lib-ui-card disablePadding>
		<app-chart-vape-sum [dayCount]="4"></app-chart-vape-sum>
	</lib-ui-card>

	<lib-ui-card disablePadding>
		<app-chart-vape-sum [dayCount]="4" [mgType]="'thcTotal'"></app-chart-vape-sum>
	</lib-ui-card>

	<lib-ui-card disablePadding class="row-span-2">
		<div class="p-2 w-full h-full">
			<app-chart-breakdown-day></app-chart-breakdown-day>
		</div>
	</lib-ui-card>

	<lib-ui-card disablePadding>

	</lib-ui-card>

	<lib-ui-card disablePadding>
		<div class="w-full h-full flex flex-col text-white text-xs font-decimaBold">
			<div class="w-full h-8 flex-none flex items-center">

			</div>
		</div>
	</lib-ui-card>

	<lib-ui-card disablePadding>

	</lib-ui-card>

	<lib-ui-card disablePadding>

	</lib-ui-card>

	<lib-ui-card disablePadding class="row-span-2">
		<app-chart-mood-day></app-chart-mood-day>
	</lib-ui-card>

	<lib-ui-card disablePadding>

	</lib-ui-card>
</div>